import token from '@/storage/token.js'
import api from '@/api/index'

export default {
  namespaced: true,
  getters: {
    breadcrumbs (state, getters, rootState, rootGetters) {
      return state.breadcrumbs
    },
  },
  state: {
    breadcrumbs: [],
  },
  mutations: {
    mutation_breadcrumbs (state, payload) {
      console.log('mutation_breadcrumbs: state=', state, ', payload=', payload)
      state.breadcrumbs = payload
    }
  },
  actions: {}
}